import React from "react";
import { useTranslation } from "react-i18next";
import { useCreateProjectExpense } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { ProjectExpense, projectExpense } from "@planzone/dto";
import { Props } from "./types";
import { Form } from "./form";
import styles from "./styles.scss";

function ProjectExpenseCreation({ project, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, createProjectExpense } = useCreateProjectExpense();
  const [formData, setFormData] = React.useState<ProjectExpense>({
    ...projectExpense,
    quantity: 1,
  });

  return (
    <Modal
      header={t("projectBudgetSynthesis.expenses.creation.title")}
      close={cancel}
    >
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          !isRequestPending &&
            createProjectExpense({ project, projectExpense: formData });
        }}
      >
        <Form formData={formData} project={project} edit={setFormData} />
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("projectBudgetSynthesis.expenses.creation.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("projectBudgetSynthesis.expenses.creation.confirm")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { ProjectExpenseCreation };
